import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Skeleton} from "@mui/material";
import PropTypes from "prop-types";

export default function LazyLoadMiniatureWithSkeleton(props) {
    const {src, alt, width, height, ...other} = props;
    const [loaded, setLoaded] = React.useState(false);
    const [loadStart, setLoadStart] = React.useState(false);

    const handleLoaded = () => {
        setLoaded(true);
    }

    const handleLoadingStart = () => {
        setLoadStart(true);
    }

    return (
        <>
            <LazyLoadImage
                {...other}
                src={src}
                alt={alt}
                afterLoad={handleLoaded}
                beforeLoad={handleLoadingStart}
                effect="blur"
                width={width}
                height={height}
            />
            {loadStart && !loaded && <Skeleton variant="rect" width='160px' height='250px'/>}
        </>

    );
}

LazyLoadMiniatureWithSkeleton.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number
}